<div class="wnt-content p-3" *ngIf="workspaceKey && isActiveDashboard">
    <div class="wnt-dashboard-container d-flex flex-column align-items-center" [ngSwitch]="viewMode">
        <div class="wnt-landing w-100 pt-5" *ngSwitchCase="WorkspaceNewTabViewMode.Landing">
            <div class="wnt-landing-prompt mb-5" cvLocalizedText langSection="Left_Nav_Popup" langKey="Choose_Dashboard_Type">Choose a dashboard type to open</div>
            <div class="font-size-18 mb-5 text-center" *ngIf="!hasDashboardAccess && !hasExistingDashboards">You do not have any dashboards shared with you at this time. Please contact your supervisor for more information.</div>
            <div class="wnt-landing-buttons-container d-flex">
                <div id="workspaceNewTab-New" class="card wnt-button" *ngIf="hasDashboardAccess"
                        (mouseenter)="newHovered = true"
                        (mouseleave)="newHovered = false"
                        (click)="openNewDashboardView()">
                    <div class="wnt-landing-button-header">
                        <div cvLocalizedText langSection="Left_Nav_Popup" langKey="New">New</div>
                    </div>
                    <div class="wnt-landing-button-icon-container">
                        <div class="wnt-landing-button-icon">
                            <img [hidden]="newHovered" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/new_dashboard_gray.svg" />
                            <img [hidden]="!newHovered" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/new_dashboard_cerulean.svg" />
                        </div>
                    </div>
                    <div class="wnt-landing-button-footer" cvLocalizedText langSection="Left_Nav_Popup" langKey="Create_New_Dash">Create a new dashboard.</div>
                </div>

                <div id="workspaceNewTab-Existing" class="card wnt-button" *ngIf="hasDashboardAccess || hasExistingDashboards"
                        (mouseenter)="existingHovered = true"
                        (mouseleave)="existingHovered = false"
                        (click)="openExistingView()">
                    <div class="wnt-landing-button-header" [class.hover]="existingHovered">
                        <div cvLocalizedText langSection="Left_Nav_Popup" langKey="Existing">Existing</div>
                    </div>
                    <div class="wnt-landing-button-icon-container">
                        <div class="wnt-landing-button-icon" [class.hover]="existingHovered">
                            <img [hidden]="existingHovered" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/existing_dashboard_gray.svg" />
                            <img [hidden]="!existingHovered" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/existing_dashboard_cerulean.svg" />
                        </div>
                    </div>
                    <div class="wnt-landing-button-footer" cvLocalizedText langSection="Left_Nav_Popup" langKey="Access_Existing_1">Access your dashboards or any that have been shared with you.</div>
                </div>

                <div id="workspaceNewTab-Template" class="card wnt-button" *ngIf="hasDashboardAccess"
                        (mouseenter)="templateHovered = true"
                        (mouseleave)="templateHovered = false"
                        (click)="openTemplateView()">
                    <div class="wnt-landing-button-header" [class.hover]="templateHovered">
                        <div cvLocalizedText langSection="Templates" langKey="Templates">Templates</div>
                    </div>
                    <div class="wnt-landing-button-icon-container">
                        <div class="wnt-landing-button-icon" [class.hover]="templateHovered">
                            <img [hidden]="templateHovered" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/template_dashboard_gray.svg" />
                            <img [hidden]="!templateHovered" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/template_dashboard_cerulean.svg" />
                        </div>
                    </div>
                    <div class="wnt-landing-button-footer" cvLocalizedText langSection="Left_Nav_Popup" langKey="Access_Template_1">Need a head start? Use a prebuilt dashboard that you can modify later.</div>
                </div>
            </div>
        </div>

        <div class="mt-4" *ngSwitchCase="WorkspaceNewTabViewMode.New">
            <cv-create-new-dashboard [workspaceKey]="workspaceKey"></cv-create-new-dashboard>
        </div>

        <div class="w-100 h-100 px-5" *ngSwitchCase="WorkspaceNewTabViewMode.Existing">
            <cv-open-existing-dashboard [workspaceKey]="workspaceKey"></cv-open-existing-dashboard>
        </div>

        <ng-container *ngSwitchCase="WorkspaceNewTabViewMode.Templates" [ngSwitch]="templateViewMode">
            <div class="w-100 h-100" *ngSwitchCase="WorkspaceTemplateViewMode.Landing">
                <cv-open-existing-template></cv-open-existing-template>
            </div>
            <div class="mt-4" *ngSwitchCase="WorkspaceTemplateViewMode.NewTemplate">
                <cv-create-new-dashboard [workspaceKey]="workspaceKey" [fromTemplate]="true"></cv-create-new-dashboard>
            </div>
            <div class="mt-4" *ngSwitchCase="WorkspaceTemplateViewMode.NewSystemTemplate">
                <cv-new-system-template></cv-new-system-template>
            </div>
        </ng-container>
    </div>
</div>